import type { ReactNode, SVGProps } from "react";

export function FxTransferIcon(props: SVGProps<SVGSVGElement>): ReactNode {
	return (
		<svg
			fill="none"
			height="16"
			viewBox="-1.9 -0.9 17 17"
			width="16"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M12.5595 8.00168C12.7007 6.66672 12.4716 5.31585 11.9025 4.12808C11.3333 2.94031 10.4511 1.97171 9.3727 1.35062C8.29429 0.729533 7.07057 0.485283 5.86372 0.650236C4.65688 0.815189 3.52386 1.38156 2.61482 2.27429C1.70577 3.16703 1.06361 4.34398 0.773432 5.6492C0.483251 6.95442 0.558746 8.32629 0.989913 9.58302C1.42108 10.8397 2.18757 11.922 3.1878 12.6864C4.18804 13.4508 5.37481 13.8612 6.59085 13.8633"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.2"
			/>
			<path
				d="M0.999512 5.021H12.1995"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.2"
			/>
			<path
				d="M0.999512 9.44238H7.26617"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.2"
			/>
			<path
				d="M6.26638 0.600098C5.14327 2.58929 4.54785 4.88695 4.54785 7.23168C4.54785 9.57641 5.14327 11.8741 6.26638 13.8633"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.2"
			/>
			<path
				d="M6.93262 0.600098C8.21206 2.86504 8.80282 5.52277 8.61862 8.18515"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.2"
			/>
			<path
				d="M9.2666 14.6002L12.5999 10.916"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.2"
			/>
			<path
				d="M12.5996 14.2318V10.916H9.59961"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.2"
			/>
		</svg>
	);
}
